import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { SocialProofPopup } from './SocialProofPopup';
import { CTAButton } from './CTAButton';
export function SalesPage() {
  const scrollToCompra = (e: React.MouseEvent) => {
    e.preventDefault();
    document.querySelector('#compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-yellow-200" data-id="element-5">
      <SocialProofPopup data-id="element-6" />

      {/* URGENCY BAR */}
      <div className="sticky top-0 z-40 bg-red-700 text-white text-center py-2 px-4 font-bold text-xs md:text-sm shadow-md" data-id="element-7">
        ⏳ Oferta por tiempo limitado – Expira en: <CountdownTimer data-id="element-8" /> | 🔥
        Acceso hoy con bonos incluidos
      </div>

      <main className="pb-12" data-id="element-9">
        {/* ═══════════════════════════════════════ */}
        {/* HERO — DOLOR + CTA SIN SCROLL          */}
        {/* ═══════════════════════════════════════ */}
        <section className="pt-5 pb-4 px-4 max-w-2xl mx-auto text-center" data-id="element-10">
          <h1 className="text-[22px] md:text-4xl font-extrabold text-gray-900 leading-tight mb-2" data-id="element-11">
            El problema no es lo que te hacen…
            <br data-id="element-12" />
            <span className="text-red-600" data-id="element-13">es lo que estás permitiendo.</span>
          </h1>

          <p className="text-base md:text-lg text-gray-600 mb-3 italic" data-id="element-14">
            Y hasta que no cambies eso… vas a seguir viviendo lo mismo.
          </p>

          <p className="text-base md:text-lg text-gray-700 mb-4 font-medium leading-snug" data-id="element-15">
            Si estás cansada de dar todo y recibir poco, este es el punto donde
            empezás a cambiar eso desde la raíz.
          </p>

          <p className="text-sm font-bold text-green-700 mb-2" data-id="element-16">
            🎁 Acceso inmediato + 4 bonos exclusivos incluidos HOY
          </p>

          <p className="text-sm text-gray-600 mb-3 font-medium italic" data-id="element-17">
            Podés seguir esperando que algo cambie… o podés empezar a cambiarlo
            hoy.
          </p>

          <CTAButton text="👉 SÍ, QUIERO ACCEDER AHORA" data-id="element-18" />

          <p className="mt-2 text-xs text-gray-500 font-medium" data-id="element-19">
            ✔ Garantía de satisfacción de 7 días
          </p>

          <a href="#compra" onClick={scrollToCompra} className="block w-[50%] max-w-[180px] mx-auto mt-4 hover:scale-105 transition-transform duration-300" data-id="element-20">
            <img src="https://cdn.magicpatterns.com/uploads/mDXLE3ji9pTmWitQ7L2dFx/ChatGPT_Image_24_mar_2026,_20_42_41.png" alt="Mujer de Alto Valor" className="w-full h-auto rounded-lg shadow-lg" data-id="element-21" />
          </a>
        </section>

        {/* ═══════════════════════════════════════ */}
        {/* IDENTIFICACIÓN — "¿Te pasó alguna vez?" */}
        {/* ═══════════════════════════════════════ */}
        <section className="py-8 px-4 bg-gray-50 border-y border-gray-200" data-id="element-22">
          <div className="max-w-2xl mx-auto text-center" data-id="element-23">
            <p className="text-lg text-gray-700 mb-4 font-medium" data-id="element-24">
              No es mala suerte. No son los demás.
              <br data-id="element-25" />
              <strong className="text-gray-900" data-id="element-26">
                Es el patrón que todavía no viste.
              </strong>
            </p>

            <h2 className="text-2xl md:text-3xl font-extrabold text-gray-900 mb-5" data-id="element-27">
              ¿Te pasó alguna vez…?
            </h2>

            <div className="space-y-3 text-lg text-gray-700 text-left max-w-xl mx-auto" data-id="element-28">
              <p className="flex items-start gap-3" data-id="element-29">
                <span className="text-red-500 mt-0.5" data-id="element-30">▸</span>
                <span data-id="element-31">
                  Prometerte no volver a caer… <strong data-id="element-32">y volver igual</strong>
                </span>
              </p>
              <p className="flex items-start gap-3" data-id="element-33">
                <span className="text-red-500 mt-0.5" data-id="element-34">▸</span>
                <span data-id="element-35">
                  Saber que merecías más… <strong data-id="element-36">pero aceptar menos</strong>
                </span>
              </p>
              <p className="flex items-start gap-3" data-id="element-37">
                <span className="text-red-500 mt-0.5" data-id="element-38">▸</span>
                <span data-id="element-39">
                  Sentir que das todo… <strong data-id="element-40">y nunca es suficiente</strong>
                </span>
              </p>
              <p className="flex items-start gap-3" data-id="element-41">
                <span className="text-red-500 mt-0.5" data-id="element-42">▸</span>
                <span data-id="element-43">Sentir culpa por querer priorizarte</span>
              </p>
              <p className="flex items-start gap-3" data-id="element-44">
                <span className="text-red-500 mt-0.5" data-id="element-45">▸</span>
                <span data-id="element-46">
                  Quedarte en relaciones que te desgastan por miedo a estar sola
                </span>
              </p>
            </div>

            <p className="mt-6 text-xl font-bold text-gray-900 bg-yellow-100 inline-block px-3 py-1" data-id="element-47">
              No es casualidad. Es un patrón.
            </p>
          </div>
        </section>

        {/* CTA */}
        <section className="py-4 px-4" data-id="element-48">
          <CTAButton text="👉 QUIERO ROMPER ESE PATRÓN AHORA" data-id="element-49" />
        </section>

        {/* ═══════════════════════════════════════ */}
        {/* REVELACIÓN                              */}
        {/* ═══════════════════════════════════════ */}
        <section className="py-8 px-4 bg-gray-900 text-white" data-id="element-50">
          <div className="max-w-2xl mx-auto text-center space-y-5" data-id="element-51">
            <p className="text-xl md:text-2xl font-bold leading-snug" data-id="element-52">
              El problema no son los demás.
            </p>
            <p className="text-2xl md:text-3xl font-extrabold text-yellow-400 leading-tight" data-id="element-53">
              Es la versión de vos que todavía está decidiendo.
            </p>
            <p className="text-lg text-gray-300" data-id="element-54">
              Y mientras esa versión siga al mando…
              <br data-id="element-55" />
              <strong className="text-white" data-id="element-56">
                vas a seguir viviendo lo mismo.
              </strong>
            </p>
          </div>
        </section>

        {/* ═══════════════════════════════════════ */}
        {/* SOLUCIÓN — Presentación del producto    */}
        {/* ═══════════════════════════════════════ */}
        <section className="py-8 px-4" data-id="element-57">
          <div className="max-w-2xl mx-auto text-center" data-id="element-58">
            <p className="text-sm font-bold text-green-600 uppercase tracking-wider mb-2" data-id="element-59">
              La solución
            </p>
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4 leading-tight" data-id="element-60">
              Mujer de Alto Valor no es solo un ebook.
            </h2>
            <p className="text-xl text-gray-700 mb-6 font-medium" data-id="element-61">
              Es el punto donde dejás de negociar con vos misma.
            </p>

            <div className="text-left max-w-xl mx-auto space-y-3 mb-6" data-id="element-62">
              <p className="flex items-start gap-3 text-lg" data-id="element-63">
                <span className="text-green-500 font-bold mt-0.5" data-id="element-64">✔</span>
                <span data-id="element-65">
                  Aprendés a poner límites <strong data-id="element-66">sin culpa</strong>
                </span>
              </p>
              <p className="flex items-start gap-3 text-lg" data-id="element-67">
                <span className="text-green-500 font-bold mt-0.5" data-id="element-68">✔</span>
                <span data-id="element-69">Detectás relaciones que te desgastan</span>
              </p>
              <p className="flex items-start gap-3 text-lg" data-id="element-70">
                <span className="text-green-500 font-bold mt-0.5" data-id="element-71">✔</span>
                <span data-id="element-72">
                  Elevás tu autoestima <strong data-id="element-73">en días</strong>
                </span>
              </p>
              <p className="flex items-start gap-3 text-lg" data-id="element-74">
                <span className="text-green-500 font-bold mt-0.5" data-id="element-75">✔</span>
                <span data-id="element-76">Cambiás la forma en la que elegís</span>
              </p>
            </div>

            <CTAButton text="👉 SÍ, QUIERO ACCEDER AHORA" data-id="element-77" />
          </div>
        </section>

        {/* ═══════════════════════════════════════ */}
        {/* ANTES vs DESPUÉS                        */}
        {/* ═══════════════════════════════════════ */}
        <section className="py-8 px-4 bg-gray-50" data-id="element-78">
          <div className="max-w-4xl mx-auto" data-id="element-79">
            <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-6" data-id="element-80">
              🔄 Antes vs Después
            </h2>
            <div className="grid md:grid-cols-2 gap-6" data-id="element-81">
              <div className="bg-white rounded-xl p-6 shadow-md border-t-4 border-red-500" data-id="element-82">
                <h3 className="text-xl font-bold text-red-600 mb-4" data-id="element-83">
                  ❌ Antes
                </h3>
                <ul className="space-y-2 text-gray-700" data-id="element-84">
                  <li className="flex items-start gap-2" data-id="element-85">
                    <span className="text-red-400" data-id="element-86">•</span>Das más de lo que
                    recibís
                  </li>
                  <li className="flex items-start gap-2" data-id="element-87">
                    <span className="text-red-400" data-id="element-88">•</span>No podés decir NO
                  </li>
                  <li className="flex items-start gap-2" data-id="element-89">
                    <span className="text-red-400" data-id="element-90">•</span>Miedo a poner límites
                  </li>
                  <li className="flex items-start gap-2" data-id="element-91">
                    <span className="text-red-400" data-id="element-92">•</span>Autoestima que
                    depende de otros
                  </li>
                  <li className="flex items-start gap-2" data-id="element-93">
                    <span className="text-red-400" data-id="element-94">•</span>Sensación de no ser
                    suficiente
                  </li>
                </ul>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-lg border-t-4 border-green-500" data-id="element-95">
                <h3 className="text-xl font-bold text-green-600 mb-4" data-id="element-96">
                  ✅ Después
                </h3>
                <ul className="space-y-2 text-gray-900 font-medium" data-id="element-97">
                  <li className="flex items-start gap-2" data-id="element-98">
                    <span className="text-green-500" data-id="element-99">✔</span>Seguridad
                    emocional real
                  </li>
                  <li className="flex items-start gap-2" data-id="element-100">
                    <span className="text-green-500" data-id="element-101">✔</span>Límites claros y
                    respetados
                  </li>
                  <li className="flex items-start gap-2" data-id="element-102">
                    <span className="text-green-500" data-id="element-103">✔</span>Relaciones sanas y
                    equilibradas
                  </li>
                  <li className="flex items-start gap-2" data-id="element-104">
                    <span className="text-green-500" data-id="element-105">✔</span>Autoestima sólida
                  </li>
                  <li className="flex items-start gap-2" data-id="element-106">
                    <span className="text-green-500" data-id="element-107">✔</span>Tranquilidad
                    emocional
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-4 px-4" data-id="element-108">
          <CTAButton text="🔓 QUIERO ESE CAMBIO AHORA" data-id="element-109" />
        </section>

        {/* ═══════════════════════════════════════ */}
        {/* BONOS — Reforzar valor                  */}
        {/* ═══════════════════════════════════════ */}
        <section className="py-8 px-4 max-w-3xl mx-auto" data-id="element-110">
          <div className="text-center mb-5" data-id="element-111">
            <h2 className="text-2xl md:text-3xl font-extrabold text-gray-900 mb-1" data-id="element-112">
              Incluye HOY sin costo adicional:
            </h2>
            <p className="text-sm text-gray-500" data-id="element-113">
              4 bonos exclusivos que refuerzan tu transformación
            </p>
          </div>

          <div className="space-y-3" data-id="element-114">
            <div className="bg-white rounded-lg border border-gray-200 p-4 flex items-start gap-3" data-id="element-115">
              <span className="text-2xl" data-id="element-116">🎁</span>
              <div data-id="element-117">
                <p className="font-bold text-gray-900" data-id="element-118">
                  25 frases poderosas para poner límites sin sentirte culpable
                </p>
                <p className="text-sm text-gray-500" data-id="element-119">
                  <span className="line-through" data-id="element-120">USD $17</span> →{' '}
                  <span className="font-bold text-green-600" data-id="element-121">GRATIS</span>
                </p>
              </div>
            </div>
            <div className="bg-white rounded-lg border border-gray-200 p-4 flex items-start gap-3" data-id="element-122">
              <span className="text-2xl" data-id="element-123">🎁</span>
              <div data-id="element-124">
                <p className="font-bold text-gray-900" data-id="element-125">
                  Test psicológico: ¿estás atrayendo relaciones desgastantes?
                </p>
                <p className="text-sm text-gray-500" data-id="element-126">
                  <span className="line-through" data-id="element-127">USD $19</span> →{' '}
                  <span className="font-bold text-green-600" data-id="element-128">GRATIS</span>
                </p>
              </div>
            </div>
            <div className="bg-white rounded-lg border border-gray-200 p-4 flex items-start gap-3" data-id="element-129">
              <span className="text-2xl" data-id="element-130">🎁</span>
              <div data-id="element-131">
                <p className="font-bold text-gray-900" data-id="element-132">
                  Cómo detectar a un hombre emocionalmente inmaduro
                </p>
                <p className="text-sm text-gray-500" data-id="element-133">
                  <span className="line-through" data-id="element-134">USD $27</span> →{' '}
                  <span className="font-bold text-green-600" data-id="element-135">GRATIS</span>
                </p>
              </div>
            </div>
            <div className="bg-white rounded-lg border border-gray-200 p-4 flex items-start gap-3" data-id="element-136">
              <span className="text-2xl" data-id="element-137">🎁</span>
              <div data-id="element-138">
                <p className="font-bold text-gray-900" data-id="element-139">
                  Reconstrucción de autoestima en 7 días
                </p>
                <p className="text-sm text-gray-500" data-id="element-140">
                  <span className="line-through" data-id="element-141">USD $25</span> →{' '}
                  <span className="font-bold text-green-600" data-id="element-142">GRATIS</span>
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* ═══════════════════════════════════════ */}
        {/* URGENCIA                                */}
        {/* ═══════════════════════════════════════ */}
        <section className="py-6 px-4 bg-red-50 border-y border-red-200" data-id="element-143">
          <div className="max-w-2xl mx-auto text-center space-y-2" data-id="element-144">
            <p className="text-lg font-bold text-red-700" data-id="element-145">
              ⚠️ Esto no va a estar disponible para siempre.
            </p>
            <p className="text-base text-gray-700" data-id="element-146">
              Hoy accedés con todos los bonos incluidos.{' '}
              <strong data-id="element-147">Después puede cambiar.</strong>
            </p>
          </div>
        </section>

        {/* ═══════════════════════════════════════ */}
        {/* PRICING — COMPRA                        */}
        {/* ═══════════════════════════════════════ */}
        <section id="compra" className="py-8 px-4 bg-yellow-50 border-y-4 border-yellow-400 scroll-mt-10" data-id="element-148">
          <div className="max-w-2xl mx-auto bg-white rounded-2xl shadow-2xl p-6 md:p-8 border border-gray-100" data-id="element-149">
            <h2 className="text-2xl font-extrabold text-center text-gray-900 mb-4 pb-3 border-b border-gray-200" data-id="element-150">
              📦 Todo lo que recibís hoy
            </h2>

            <div className="space-y-2 mb-5 text-base font-medium text-gray-800" data-id="element-151">
              <p className="flex items-center gap-2" data-id="element-152">
                <span className="text-green-500" data-id="element-153">✔</span> Ebook completo MUJER
                DE ALTO VALOR
              </p>
              <p className="flex items-center gap-2" data-id="element-154">
                <span className="text-green-500" data-id="element-155">✔</span> Bono: 25 frases para
                poner límites
              </p>
              <p className="flex items-center gap-2" data-id="element-156">
                <span className="text-green-500" data-id="element-157">✔</span> Bono: Test
                psicológico de relaciones
              </p>
              <p className="flex items-center gap-2" data-id="element-158">
                <span className="text-green-500" data-id="element-159">✔</span> Bono: Guía de red
                flags emocionales
              </p>
              <p className="flex items-center gap-2" data-id="element-160">
                <span className="text-green-500" data-id="element-161">✔</span> Bono: Workbook de
                autoestima
              </p>
            </div>

            <div className="flex flex-wrap justify-center gap-3 mb-5 text-xs font-bold text-gray-600 bg-gray-50 p-2 rounded-lg" data-id="element-162">
              <span data-id="element-163">✔ Acceso inmediato</span>
              <span data-id="element-164">✔ Descarga digital</span>
              <span data-id="element-165">✔ Acceso de por vida</span>
            </div>

            <div className="text-center mb-5" data-id="element-166">
              <p className="text-xl text-gray-400 line-through mb-1" data-id="element-167">
                Precio regular: $49.990
              </p>
              <p className="text-lg font-bold text-red-600 mb-1" data-id="element-168">
                🔥 HOY SOLO:
              </p>
              <p className="text-5xl md:text-6xl font-extrabold text-gray-900 tracking-tight" data-id="element-169">
                $19.990
              </p>
            </div>

            <CTAButton text="👉 OBTENER MUJER DE ALTO VALOR AHORA" href="https://pagos.crecerdigital.shop/cart/42883213394009:1" data-id="element-170" />

            <p className="mt-4 text-center text-xs text-gray-500 font-medium" data-id="element-171">
              🔒 Pago 100% seguro · Garantía 7 días
            </p>
          </div>
        </section>

        {/* ═══════════════════════════════════════ */}
        {/* GARANTÍA                                */}
        {/* ═══════════════════════════════════════ */}
        <section className="py-8 px-4 bg-gray-900 text-white text-center" data-id="element-172">
          <div className="max-w-2xl mx-auto" data-id="element-173">
            <p className="text-4xl mb-2" data-id="element-174">🛡️</p>
            <h2 className="text-2xl md:text-3xl font-bold mb-3 text-yellow-400" data-id="element-175">
              Garantía sin riesgo – 7 días
            </h2>
            <p className="text-lg text-gray-300 mb-3" data-id="element-176">
              Si no sentís que este libro te da claridad emocional y
              herramientas reales…
            </p>
            <p className="text-xl font-bold mb-2" data-id="element-177">
              Te devolvemos el 100% del dinero.
            </p>
            <p className="text-gray-400 italic" data-id="element-178">Sin preguntas.</p>
          </div>
        </section>

        {/* ═══════════════════════════════════════ */}
        {/* PRUEBA SOCIAL                           */}
        {/* ═══════════════════════════════════════ */}
        <section className="py-8 px-4 max-w-3xl mx-auto" data-id="element-179">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-6" data-id="element-180">
            Mujeres que ya dejaron de repetir lo mismo
          </h2>

          <div className="space-y-4" data-id="element-181">
            {[{
            text: 'Me hizo darme cuenta de cosas que venía ignorando hace años. Después de leerlo, empecé a poner límites de verdad.',
            author: 'Camila, 27'
          }, {
            text: 'Por primera vez entendí por qué siempre terminaba en el mismo tipo de relación.',
            author: 'Sofía, 31'
          }, {
            text: 'Sentí que alguien me estaba explicando exactamente lo que me pasaba, pero con una salida clara.',
            author: 'Valentina, 24'
          }, {
            text: 'Después de aplicarlo, dejé de aceptar cosas que antes normalizaba.',
            author: 'Martina, 29'
          }].map((t, i) => <div key={i} className="bg-gray-50 p-5 rounded-lg border border-gray-100" data-id="element-182">
                <div className="flex text-yellow-400 mb-2 text-sm" data-id="element-183">★★★★★</div>
                <p className="text-gray-800 font-medium italic mb-2" data-id="element-184">
                  "{t.text}"
                </p>
                <p className="text-gray-500 text-sm font-bold" data-id="element-185">— {t.author}</p>
              </div>)}
          </div>
        </section>

        {/* CTA */}
        <section className="py-4 px-4" data-id="element-186">
          <CTAButton text="👉 QUIERO EMPEZAR MI CAMBIO HOY" data-id="element-187" />
        </section>

        {/* ═══════════════════════════════════════ */}
        {/* FAQ                                     */}
        {/* ═══════════════════════════════════════ */}
        <section className="py-8 px-4 max-w-2xl mx-auto" data-id="element-188">
          <h2 className="text-2xl font-bold text-center text-gray-900 mb-5" data-id="element-189">
            Preguntas frecuentes
          </h2>
          <div className="space-y-3" data-id="element-190">
            {[{
            q: '¿Es un libro motivacional?',
            a: 'No. Es un sistema práctico con herramientas aplicables.'
          }, {
            q: '¿Es material digital?',
            a: 'Sí. Recibís acceso inmediato después de comprar.'
          }, {
            q: '¿Sirve si ya intenté mejorar mi autoestima?',
            a: 'Sí. El enfoque está en cambiar patrones emocionales profundos.'
          }, {
            q: '¿Cuánto tiempo lleva aplicarlo?',
            a: 'Podés empezar desde el primer día.'
          }].map((faq, i) => <div key={i} className="bg-white border border-gray-200 rounded-lg p-4" data-id="element-191">
                <h4 className="font-bold text-gray-900 mb-1" data-id="element-192">{faq.q}</h4>
                <p className="text-gray-600 text-sm" data-id="element-193">{faq.a}</p>
              </div>)}
          </div>
        </section>

        {/* ═══════════════════════════════════════ */}
        {/* REASEGURO                               */}
        {/* ═══════════════════════════════════════ */}
        <section className="py-6 px-4 bg-gray-50 border-y border-gray-200" data-id="element-194">
          <div className="max-w-2xl mx-auto text-center space-y-3" data-id="element-195">
            <p className="text-lg text-gray-700 font-medium" data-id="element-196">
              No necesitás creer en todo esto.
            </p>
            <p className="text-lg text-gray-900 font-bold" data-id="element-197">
              Solo necesitás darte la oportunidad de probarlo.
            </p>
            <p className="text-sm text-gray-500" data-id="element-198">
              Tenés 7 días de garantía. Si no sentís un cambio, podés pedir
              devolución.
            </p>
          </div>
        </section>

        {/* ═══════════════════════════════════════ */}
        {/* CIERRE FINAL — Impacto emocional        */}
        {/* ═══════════════════════════════════════ */}
        <section className="py-10 px-4 bg-gray-900 text-white text-center" data-id="element-199">
          <div className="max-w-2xl mx-auto space-y-4" data-id="element-200">
            <p className="text-2xl md:text-3xl font-extrabold leading-tight" data-id="element-201">
              No hay punto medio.
            </p>
            <p className="text-lg text-gray-300" data-id="element-202">O seguís siendo la misma…</p>
            <p className="text-xl md:text-2xl font-bold text-yellow-400" data-id="element-203">
              o empezás a convertirte en la mujer que ya sabés que podés ser.
            </p>
            <p className="text-base text-gray-400 italic" data-id="element-204">
              Pero si llegaste hasta acá… sabés cuál de las dos vas a elegir.
            </p>

            <p className="text-sm font-bold text-green-400 pt-2" data-id="element-205">
              🎁 Acceso inmediato + 4 bonos incluidos HOY
            </p>

            <div className="pt-2" data-id="element-206">
              <CTAButton text="ACCEDER HOY MISMO" href="https://pagos.crecerdigital.shop/cart/42883213394009:1" data-id="element-207" />
            </div>

            <p className="text-sm text-gray-400 pt-1" data-id="element-208">
              Empezás hoy. El cambio también.
            </p>
          </div>
        </section>
      </main>
    </div>;
}